import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { addAsset, editAsset, getUsers, getLocations, addLocation } from '../../store/actions/assetActions';
import { IoClose } from 'react-icons/io5';

// Add custom Option component for colored squares
const CustomOption = (props) => {
    const { innerRef, innerProps, data, isFocused } = props;
    const getColorForImpact = (impact) => {
        const colors = {
            "insignificant": "#0081A7",
            "minor": "#00AFB9",
            "moderate": "#FED9B7",
            "major": "#F07167",
            "catastrophe": "#b4170b",
            "unassessed": "#CCCCCC"
        };
        return colors[impact] || "#CCCCCC";
    };

    return (
        <div
            ref={innerRef}
            {...innerProps}
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: '6px 8px',
                backgroundColor: isFocused ? '#EEF0ED' : 'white',
                cursor: 'pointer',
            }}
        >
            <div
                style={{
                    width: 12,
                    height: 12,
                    marginRight: 8,
                    backgroundColor: getColorForImpact(data.value),
                    borderRadius: 2,
                }}
            />
            <span>{data.label}</span>
        </div>
    );
};

// Update the CustomSingleValue component
const CustomSingleValue = (props) => {
    const { data } = props;
    const getColorForImpact = (impact) => {
        const colors = {
            "insignificant": "#0081A7",
            "minor": "#00AFB9",
            "moderate": "#FED9B7",
            "major": "#F07167",
            "catastrophe": "#b4170b"
        };
        return colors[impact] || "#CCCCCC";
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
            <div
                style={{
                    width: 10,
                    height: 10,
                    marginRight: 5,
                    backgroundColor: getColorForImpact(data.value),
                    borderRadius: 2,
                }}
            />
            <span>{data.label}</span>
        </div>
    );
};

const AssetOverlay = ({ close, asset, addAssetFN, editAssetFN, users, getUsers, locations, getLocationsFN, addLocationFN, department_id, compliance_id, isComp }) => {
    const [formData, setFormData] = useState({
        name: '',
        category: '',
        func: '',
        status: 'active',
        location: '',
        sensitivity_level: 'internal',
        owner_id: null,
        confidentiality: 'unassessed',
        integrity: 'unassessed',
        availability: 'unassessed',
        department: '',
        information_type: [],
        vendor: '',
        expiry_date: '',
        license_type: '',
        number_of_users: '',
        contact: '',
        serial_number: '',
        warranty_expiry: '',
        model: '',
        assigned_to: '',
        value: 0,
        information_types: [],
        data_classification: '',
        storage_location: '',
        backup_status: '',
        ip_addresses: '',
        network_segments: '',
        configuration_details: '',
        team_size: '',
        skillset: '',
        roles_responsibilities: '',
        training_records: '',
        square_footage: '',
        capacity: '',
        access_controls: '',
        environmental_controls: '',
        document_type: '',
        version_control: '',
        maintenance_schedule: '',
        sla_details: '',
        contract_terms: '',
    });

    useEffect(() => {
        if (asset) {
            let informationType = [];
            if (asset.information_type) {
                try {
                    informationType = typeof asset.information_type === 'string'
                        ? JSON.parse(asset.information_type)
                        : asset.information_type;
                } catch (e) {
                    informationType = [];
                }
            }
            const assetData = { ...asset };
            if (asset.category === 'services') {
                assetData.vendor = asset.services_vendor || asset.vendor || '';
                assetData.expiry_date = asset.services_expiry_date || asset.expiry_date || '';
                assetData.license_type = asset.services_license_type || asset.license_type || '';
                assetData.number_of_users = asset.services_number_of_users || asset.number_of_users || '';
                assetData.contact = asset.services_contact || asset.contact || '';
                assetData.sla_details = asset.services_sla_details || asset.sla_details || '';
                assetData.contract_terms = asset.services_contract_terms || asset.contract_terms || '';
            } else if (asset.category === 'virtual_machine') {
                assetData.serial_number = asset.vm_serial_number || asset.serial_number || '';
                assetData.warranty_expiry = asset.vm_warranty_expiry || asset.warranty_expiry || '';
                assetData.model = asset.vm_model || asset.model || '';
                assetData.assigned_to = asset.vm_assigned_to || asset.assigned_to || '';
            } else if (asset.category === 'information_assets') {
                assetData.data_classification = asset.ia_data_classification || asset.data_classification || '';
                assetData.storage_location = asset.ia_storage_location || asset.storage_location || '';
                assetData.backup_status = asset.ia_backup_status || asset.backup_status || '';
            } else if (asset.category === 'network_assets') {
                assetData.warranty_expiry = asset.na_warranty_expiry || asset.warranty_expiry || '';
                assetData.ip_addresses = asset.na_ip_addresses || asset.ip_addresses || '';
                assetData.network_segments = asset.na_network_segments || asset.network_segments || '';
                assetData.configuration_details = asset.na_configuration_details || asset.configuration_details || '';
            } else if (asset.category === 'organizational_people_assets') {
                assetData.team_size = asset.opa_team_size || asset.team_size || '';
                assetData.skillset = asset.opa_skillset || asset.skillset || '';
                assetData.roles_responsibilities = asset.opa_roles_responsibilities || asset.roles_responsibilities || '';
                assetData.training_records = asset.opa_training_records || asset.training_records || '';
            } else if (asset.category === 'facilities') {
                assetData.square_footage = asset.fa_square_footage || asset.square_footage || '';
                assetData.capacity = asset.fa_capacity || asset.capacity || '';
                assetData.access_controls = asset.fa_access_controls || asset.access_controls || '';
                assetData.environmental_controls = asset.fa_environmental_controls || asset.environmental_controls || '';
            } else if (asset.category === 'documentation_assets') {
                assetData.document_type = asset.da_document_type || asset.document_type || '';
                assetData.version_control = asset.da_version_control || asset.version_control || '';
            }
            
            if (asset.category === 'hardware') {
                assetData.maintenance_schedule = asset.maintenance_schedule || '';
            }
            
            if (asset.category === 'services') {
                assetData.sla_details = asset.services_sla_details || asset.sla_details || '';
                assetData.contract_terms = asset.services_contract_terms || asset.contract_terms || '';
            }
            setFormData({
                ...assetData,
                expiry_date: assetData.expiry_date ? assetData.expiry_date.split('T')[0] : '',
                warranty_expiry: assetData.warranty_expiry ? assetData.warranty_expiry.split('T')[0] : '',
                owner_id: assetData.owner_id || null,
                department: assetData.department || '',
                information_type: informationType
            });
        }
    }, [asset]);

    useEffect(() => {
        getUsers();
    }, [getUsers]);

    useEffect(() => {
        getLocationsFN(department_id);
    }, [getLocationsFN, department_id]);

    const locationOptions = (locations || []).map((l) => ({ value: l.name, label: l.name }));

    const handleLocationCreate = async (inputValue) => {
        await addLocationFN(inputValue, department_id);
        setFormData({ ...formData, location: inputValue });
    };

    const categoryOptions = [
        { value: 'hardware', label: 'Hardware' },
        { value: 'software', label: 'Software' },
        { value: 'services', label: 'Services' },
        { value: 'virtual_machine', label: 'Virtual Machine' },
        { value: 'information_assets', label: 'Information Assets' },
        { value: 'network_assets', label: 'Network Assets' },
        { value: 'organizational_people_assets', label: 'Organizational/People Assets' },
        { value: 'facilities', label: 'Facilities' },
        { value: 'documentation_assets', label: 'Documentation Assets' },
        { value: 'iot', label: 'IoT' }
    ];

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'retired', label: 'Retired' },
        { value: 'pending', label: 'Pending' }
    ];

    const sensitivityOptions = [
        { value: 'public', label: 'Public' },
        { value: 'internal', label: 'Internal' },
        { value: 'confidential', label: 'Confidential' },
        { value: 'restricted', label: 'Restricted' }
    ];

    const licenseTypeOptions = [
        { value: 'perpetual', label: 'Perpetual' },
        { value: 'subscription', label: 'Subscription' },
        { value: 'trial', label: 'Trial' },
        { value: 'open_source', label: 'Open Source' }
    ];

    const dataClassificationOptions = [
        { value: 'public', label: 'Public' },
        { value: 'internal', label: 'Internal' },
        { value: 'confidential', label: 'Confidential' },
        { value: 'restricted', label: 'Restricted' }
    ];

    const backupStatusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'not_configured', label: 'Not Configured' }
    ];

    const documentTypeOptions = [
        { value: 'policy', label: 'Policy' },
        { value: 'procedure', label: 'Procedure' },
        { value: 'manual', label: 'Manual' },
        { value: 'standard', label: 'Standard' },
        { value: 'other', label: 'Other' }
    ];

    const ciaOptions = [
        { value: 'insignificant', label: 'Insignificant', color: "#0081A7" },
        { value: 'minor', label: 'Minor', color: "#00AFB9" },
        { value: 'moderate', label: 'Moderate', color: "#FED9B7" },
        { value: 'major', label: 'Major', color: "#F07167" },
        { value: 'catastrophe', label: 'Catastrophe', color: "#b4170b" }
    ];


    const informationTypes = [
        "Customer Data",
        "Employee Data",
        "Financial Data",
        "PII",
        "Intellectual Property",
        "Business Critical",
        "Business Documents",
        "Operational Data",
        "Public Information",
        "Application Data",
        "Infrastructure",
        "None",
    ];



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isComp) {
            try {
                const submitData = {
                    ...formData,
                    information_type: formData.information_type,
                    compliance_id: compliance_id
                };
                if (asset) {
                    await editAssetFN(asset.id, submitData);
                } else {
                    await addAssetFN(submitData);
                }
                close();
            } catch (error) {
                console.error('Error saving asset:', error);
            }
        } else {
            try {
                const submitData = {
                    ...formData,
                    information_type: formData.information_type,
                    department_id: department_id
                };
                if (asset) {
                    await editAssetFN(asset.id, submitData);
                } else {
                    await addAssetFN(submitData);
                }
                close();
            } catch (error) {
                console.error('Error saving asset:', error);
            }
        }
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            border: 'none',
            backgroundColor: '#EEF0ED',
            padding: '0 8px',
            minHeight: '36px',
            outline: 'none',
            transition: 'box-shadow 0.1s',
            boxShadow: 'inset 0 0 0 0 #3b3b3b',
            '&:hover': {
                boxShadow: 'inset 0 -2px 0 0 #3b3b3b',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
            color: state.isSelected ? 'white' : '#3b3b3b',
            padding: '6px 8px',
            fontSize: '14px',
            '&:hover': {
                backgroundColor: '#EEF0ED',
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#3b3b3b',
            fontSize: '14px',
            padding: '2px 0',
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: 'white',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            marginTop: '2px',
        }),
        menuList: (provided) => ({
            ...provided,
            padding: '4px 0',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0 4px',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            padding: '0 4px',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '4px',
        }),
    };

    return (
        <div className="p-8">
            <div className="p-6 bg-white rounded-lg max-h-[80vh] flex flex-col">

                {/* Header */}
                <div className="flex justify-between items-center mb-4 relative">
                    <h1 className="text-lg font-semibold text-[#3b3b3b]">Asset Details</h1>
                    <IoClose
                        className="w-6 h-6 cursor-pointer text-[#3b3b3b] hover:text-[#3b3b3b]/70 absolute top-0 right-0"
                        onClick={handleSubmit}
                    />
                </div>

                {/* Scrollable content */}
                <div className="overflow-y-auto flex-1 pr-2">

                    <form onSubmit={handleSubmit} className="space-y-4">
                        {/* Basic Information */}
                        <div className="mb-6">
                            <input
                                type="text"
                                placeholder="Name"
                                value={formData.name}
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                className="w-full p-3 rounded mb-4 bg-[#EEF0ED] text-black text-sm"
                                style={{
                                    border: 'none',
                                    backgroundColor: '#EEF0ED',
                                    padding: '8px',
                                    outline: 'none',
                                    transition: 'box-shadow 0.1s',
                                    boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                }}
                                onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                required
                            />

                            <textarea
                                placeholder="Description"
                                value={formData.description}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                className="w-full h-24 p-3 mb-4 rounded bg-[#EEF0ED] text-black text-sm"
                                style={{
                                    border: 'none',
                                    backgroundColor: '#EEF0ED',
                                    padding: '8px',
                                    outline: 'none',
                                    transition: 'box-shadow 0.1s',
                                    boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                }}
                                onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                            />

                            <div className="mb-6">
                                <label className="text-[#3b3b3b] mb-2 text-sm block">
                                    Information Types
                                </label>

                                <div className="border border-gray-200 rounded-lg p-4">
                                    <div className="grid grid-cols-2 gap-y-2 gap-x-6">
                                        {informationTypes.map((type) => {
                                            const checked = formData.information_types?.includes(type);

                                            return (
                                                <label
                                                    key={type}
                                                    className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer select-none"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="
                w-4 h-4 
                rounded 
                border-gray-300 
                text-[#3b3b3b] 
                focus:ring-[#3b3b3b]
              "
                                                        checked={checked}
                                                        onChange={(e) => {
                                                            const next = e.target.checked
                                                                ? [...(formData.information_types || []), type]
                                                                : (formData.information_types || []).filter(t => t !== type);

                                                            setFormData({
                                                                ...formData,
                                                                information_types: next,
                                                            });
                                                        }}
                                                    />
                                                    {type}
                                                </label>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>


                            <div className="flex flex-col">
                                {/* <label className="text-[#3b3b3b] mb-2 text-sm">Function</label> */}
                                <input
                                    type="text"
                                    placeholder="Function"
                                    value={formData.func}
                                    onChange={(e) => setFormData({ ...formData, func: e.target.value })}
                                    className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                    style={{
                                        border: 'none',
                                        backgroundColor: '#EEF0ED',
                                        padding: '8px',
                                        outline: 'none',
                                        transition: 'box-shadow 0.1s',
                                        boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                    }}
                                    onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                    onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                />
                            </div>
                            <div className="flex flex-col mt-4">
                                <input
                                    type="text"
                                    placeholder="Vendor"
                                    value={formData.vendor}
                                    onChange={(e) => setFormData({ ...formData, vendor: e.target.value })}
                                    className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                    style={{
                                        border: 'none',
                                        backgroundColor: '#EEF0ED',
                                        padding: '8px',
                                        outline: 'none',
                                        transition: 'box-shadow 0.1s',
                                        boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                    }}
                                    onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                    onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                />
                            </div>
                        </div>

                        {/* Category, Function, Status, Location */}
                        <div className="grid grid-cols-4 gap-4 mb-6">
                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Category</label>
                                <Select
                                    value={categoryOptions.find(opt => opt.value === formData.category)}
                                    onChange={(opt) => setFormData({ ...formData, category: opt.value })}
                                    options={categoryOptions}
                                    styles={customStyles}
                                    className="text-sm"
                                    isSearchable={false}
                                    required
                                />
                            </div>

                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Status</label>
                                <Select
                                    value={statusOptions.find(opt => opt.value === formData.status)}
                                    onChange={(opt) => setFormData({ ...formData, status: opt.value })}
                                    options={statusOptions}
                                    styles={customStyles}
                                    className="text-sm"
                                    isSearchable={false}
                                />
                            </div>
                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Location</label>
                                <CreatableSelect
                                    isClearable
                                    options={locationOptions}
                                    value={formData.location ? { value: formData.location, label: formData.location } : null}
                                    onChange={(opt) => setFormData({ ...formData, location: opt ? opt.value : '' })}
                                    onCreateOption={handleLocationCreate}
                                    styles={customStyles}
                                    className="text-sm"
                                    placeholder="Select or type a location..."
                                    formatCreateLabel={(input) => `Save "${input}"`}
                                />
                            </div>
                            {/* <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">Department</label>
                            <input
                                type="text"
                                value={formData.department}
                                onChange={(e) => setFormData({ ...formData, department: e.target.value })}
                                placeholder="IT, HR, Finance, etc."
                                className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                style={{
                                    border: 'none',
                                    backgroundColor: '#EEF0ED',
                                    padding: '8px',
                                    outline: 'none',
                                    transition: 'box-shadow 0.1s',
                                    boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                }}
                                onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                            />
                        </div> */}
                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Owner</label>
                                <Select
                                    value={users.find(u => u.user_id === formData.owner_id)}
                                    onChange={(opt) => setFormData({ ...formData, owner_id: opt ? opt.user_id : null })}
                                    options={users}
                                    getOptionLabel={option => `${option.first_name} ${option.last_name}`}
                                    getOptionValue={option => option.user_id}
                                    isClearable
                                    styles={customStyles}
                                    className="text-sm"
                                    isSearchable={false}
                                />
                            </div>
                        </div>

                        <div className="flex gap-4 mb-6">

                            {/* Sensitivity Level (same size as before) */}
                            <div className="flex flex-col" style={{ width: "250px" }}>
                                <label className="text-[#3b3b3b] mb-2 text-sm">Sensitivity Level</label>
                                <Select
                                    value={sensitivityOptions.find(opt => opt.value === formData.sensitivity_level)}
                                    onChange={(opt) => setFormData({ ...formData, sensitivity_level: opt.value })}
                                    options={sensitivityOptions}
                                    styles={customStyles}
                                    className="text-sm"
                                    isSearchable={false}
                                />
                            </div>

                            {/* Value (small, border removed, compact) */}
                            <div className="flex flex-col" style={{ width: "100px" }}>
                                <label className="text-[#3b3b3b] mb-2 text-sm">Value</label>

                                <div className="relative">
                                    {/* $ Prefix */}
                                    <span className="absolute left-2 top-1/2 -translate-y-1/2 text-sm text-gray-600 select-none">
                                        $
                                    </span>

                                    {/* Numeric Input */}
                                    <input
                                        type="number"
                                        min="0"
                                        className="
        w-full 
        pl-5 pr-2 py-2    /* pl-5 so text doesn't overlap $ */
        rounded 
        bg-[#EEF0ED] 
        text-black 
        text-sm 
        focus:outline-none 
      "
                                        style={{
                                            border: "none",
                                            boxShadow: "none",
                                            appearance: "none",
                                            WebkitAppearance: "none",
                                            MozAppearance: "textfield"
                                        }}
                                        value={formData.value ?? ""}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                value: e.target.value === "" ? "" : Number(e.target.value),
                                            })
                                        }
                                    />
                                </div>
                            </div>


                        </div>






                        {/* CIA Fields */}
                        <div className="grid grid-cols-3 gap-4 mb-6">
                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Confidentiality</label>
                                <Select
                                    value={ciaOptions.find(opt => opt.value === formData.confidentiality)}
                                    onChange={(opt) => setFormData({ ...formData, confidentiality: opt.value })}
                                    options={ciaOptions}
                                    styles={customStyles}
                                    className="text-sm"
                                    components={{
                                        Option: CustomOption,
                                        SingleValue: CustomSingleValue
                                    }}
                                    isSearchable={false}
                                />
                            </div>
                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Integrity</label>
                                <Select
                                    value={ciaOptions.find(opt => opt.value === formData.integrity)}
                                    onChange={(opt) => setFormData({ ...formData, integrity: opt.value })}
                                    options={ciaOptions}
                                    styles={customStyles}
                                    className="text-sm"
                                    components={{
                                        Option: CustomOption,
                                        SingleValue: CustomSingleValue
                                    }}
                                    isSearchable={false}
                                />
                            </div>
                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">Availability</label>
                                <Select
                                    value={ciaOptions.find(opt => opt.value === formData.availability)}
                                    onChange={(opt) => setFormData({ ...formData, availability: opt.value })}
                                    options={ciaOptions}
                                    styles={customStyles}
                                    className="text-sm"
                                    components={{
                                        Option: CustomOption,
                                        SingleValue: CustomSingleValue
                                    }}
                                    isSearchable={false}
                                />
                            </div>
                        </div>

                        {/* Software-specific fields */}
                        {formData.category === 'software' && (
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Expiry Date</label>
                                    <input
                                        type="date"
                                        value={formData.expiry_date}
                                        onChange={(e) => setFormData({ ...formData, expiry_date: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">License Type</label>
                                    <Select
                                        value={licenseTypeOptions.find(opt => opt.value === formData.license_type)}
                                        onChange={(opt) => setFormData({ ...formData, license_type: opt ? opt.value : '' })}
                                        options={licenseTypeOptions}
                                        styles={customStyles}
                                        className="text-sm"
                                        isSearchable={false}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Number of Users</label>
                                    <input
                                        type="number"
                                        value={formData.number_of_users}
                                        onChange={(e) => setFormData({ ...formData, number_of_users: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                            </div>
                        )}

                        {formData.category === 'hardware' && (
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Serial Number</label>
                                    <input
                                        type="text"
                                        value={formData.serial_number}
                                        onChange={(e) => setFormData({ ...formData, serial_number: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Warranty Expiry</label>
                                    <input
                                        type="date"
                                        value={formData.warranty_expiry}
                                        onChange={(e) => setFormData({ ...formData, warranty_expiry: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Model</label>
                                    <input
                                        type="text"
                                        value={formData.model}
                                        onChange={(e) => setFormData({ ...formData, model: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Assigned To</label>
                                    <input
                                        type="text"
                                        value={formData.assigned_to}
                                        onChange={(e) => setFormData({ ...formData, assigned_to: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Maintenance Schedule</label>
                                    <textarea
                                        value={formData.maintenance_schedule}
                                        onChange={(e) => setFormData({ ...formData, maintenance_schedule: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                            </div>
                        )}

                        {formData.category === 'services' && (
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Expiry Date</label>
                                    <input
                                        type="date"
                                        value={formData.expiry_date}
                                        onChange={(e) => setFormData({ ...formData, expiry_date: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">License Type</label>
                                    <Select
                                        value={licenseTypeOptions.find(opt => opt.value === formData.license_type)}
                                        onChange={(opt) => setFormData({ ...formData, license_type: opt ? opt.value : '' })}
                                        options={licenseTypeOptions}
                                        styles={customStyles}
                                        className="text-sm"
                                        isSearchable={false}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Number of Users</label>
                                    <input
                                        type="number"
                                        value={formData.number_of_users}
                                        onChange={(e) => setFormData({ ...formData, number_of_users: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Contact</label>
                                    <input
                                        type="text"
                                        value={formData.contact}
                                        onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">SLA Details</label>
                                    <textarea
                                        value={formData.sla_details}
                                        onChange={(e) => setFormData({ ...formData, sla_details: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Contract Terms</label>
                                    <textarea
                                        value={formData.contract_terms}
                                        onChange={(e) => setFormData({ ...formData, contract_terms: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                            </div>
                        )}

                        {formData.category === 'virtual_machine' && (
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Serial Number</label>
                                    <input
                                        type="text"
                                        value={formData.serial_number}
                                        onChange={(e) => setFormData({ ...formData, serial_number: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Warranty Expiry</label>
                                    <input
                                        type="date"
                                        value={formData.warranty_expiry}
                                        onChange={(e) => setFormData({ ...formData, warranty_expiry: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Model</label>
                                    <input
                                        type="text"
                                        value={formData.model}
                                        onChange={(e) => setFormData({ ...formData, model: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Assigned To</label>
                                    <input
                                        type="text"
                                        value={formData.assigned_to}
                                        onChange={(e) => setFormData({ ...formData, assigned_to: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                            </div>
                        )}

                        {formData.category === 'information_assets' && (
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Data Classification</label>
                                    <Select
                                        value={dataClassificationOptions.find(opt => opt.value === formData.data_classification)}
                                        onChange={(opt) => setFormData({ ...formData, data_classification: opt ? opt.value : '' })}
                                        options={dataClassificationOptions}
                                        styles={customStyles}
                                        className="text-sm"
                                        isSearchable={false}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Storage Location</label>
                                    <input
                                        type="text"
                                        value={formData.storage_location}
                                        onChange={(e) => setFormData({ ...formData, storage_location: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Backup Status</label>
                                    <Select
                                        value={backupStatusOptions.find(opt => opt.value === formData.backup_status)}
                                        onChange={(opt) => setFormData({ ...formData, backup_status: opt ? opt.value : '' })}
                                        options={backupStatusOptions}
                                        styles={customStyles}
                                        className="text-sm"
                                        isSearchable={false}
                                    />
                                </div>
                            </div>
                        )}

                        {formData.category === 'network_assets' && (
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Warranty Expiry</label>
                                    <input
                                        type="date"
                                        value={formData.warranty_expiry}
                                        onChange={(e) => setFormData({ ...formData, warranty_expiry: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Network Segments</label>
                                    <input
                                        type="text"
                                        value={formData.network_segments}
                                        onChange={(e) => setFormData({ ...formData, network_segments: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">IP Addresses</label>
                                    <textarea
                                        value={formData.ip_addresses}
                                        onChange={(e) => setFormData({ ...formData, ip_addresses: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Configuration Details</label>
                                    <textarea
                                        value={formData.configuration_details}
                                        onChange={(e) => setFormData({ ...formData, configuration_details: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                            </div>
                        )}

                        {formData.category === 'organizational_people_assets' && (
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Team Size</label>
                                    <input
                                        type="number"
                                        value={formData.team_size}
                                        onChange={(e) => setFormData({ ...formData, team_size: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Skillset</label>
                                    <textarea
                                        value={formData.skillset}
                                        onChange={(e) => setFormData({ ...formData, skillset: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Roles & Responsibilities</label>
                                    <textarea
                                        value={formData.roles_responsibilities}
                                        onChange={(e) => setFormData({ ...formData, roles_responsibilities: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Training Records</label>
                                    <textarea
                                        value={formData.training_records}
                                        onChange={(e) => setFormData({ ...formData, training_records: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                            </div>
                        )}

                        {formData.category === 'facilities' && (
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Square Footage</label>
                                    <input
                                        type="number"
                                        value={formData.square_footage}
                                        onChange={(e) => setFormData({ ...formData, square_footage: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Capacity</label>
                                    <input
                                        type="text"
                                        value={formData.capacity}
                                        onChange={(e) => setFormData({ ...formData, capacity: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Access Controls</label>
                                    <textarea
                                        value={formData.access_controls}
                                        onChange={(e) => setFormData({ ...formData, access_controls: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                                <div className="flex flex-col col-span-2">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Environmental Controls</label>
                                    <textarea
                                        value={formData.environmental_controls}
                                        onChange={(e) => setFormData({ ...formData, environmental_controls: e.target.value })}
                                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                            </div>
                        )}

                        {formData.category === 'documentation_assets' && (
                            <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Document Type</label>
                                    <Select
                                        value={documentTypeOptions.find(opt => opt.value === formData.document_type)}
                                        onChange={(opt) => setFormData({ ...formData, document_type: opt ? opt.value : '' })}
                                        options={documentTypeOptions}
                                        styles={customStyles}
                                        className="text-sm"
                                        isSearchable={false}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-[#3b3b3b] mb-2 text-sm">Version Control</label>
                                    <input
                                        type="text"
                                        value={formData.version_control}
                                        onChange={(e) => setFormData({ ...formData, version_control: e.target.value })}
                                        className="w-full p-2 rounded bg-[#EEF0ED] text-black text-sm"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#EEF0ED',
                                            padding: '8px',
                                            outline: 'none',
                                            transition: 'box-shadow 0.1s',
                                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                                        }}
                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="flex justify-end space-x-3 pt-4">
                            <button
                                type="button"
                                onClick={close}
                                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-4 py-2 bg-[#3b3b3b] text-white rounded-md hover:bg-opacity-90"
                            >
                                {asset ? 'Save Changes' : 'Add Asset'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    console.log("Locations ",  state.asset.locations,)
    return {
        users: state.asset.users,
        locations: state.asset.locations,
        department_id: state.department.activeDepartmentId,
        compliance_id: state.compliance.activeComplianceId
    }
};

const mapDispatchToProps = (dispatch) => ({
    addAssetFN: (data) => dispatch(addAsset(data)),
    editAssetFN: (id, data) => dispatch(editAsset(id, data)),
    getUsers: () => dispatch(getUsers()),
    getLocationsFN: () => dispatch(getLocations()),
    addLocationFN: (name, departmentId) => dispatch(addLocation(name, departmentId)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(AssetOverlay);